import "./filterPanelStyles.css";
import { Button } from "../Button";
import { Dropdown } from "../dropdown";
import { ToggleButton } from "../toggleButton";
import { DropdownSelector } from "./dropdownSelector";
import { MultiSelectGroup } from "../multiSelectGroup";
import { Range, getTrackBackground } from "react-range";
import { formatPrice } from "../../../utils/formatPrice";
import { PropertyTypeSelector } from "./propertyTypeSelector";
import { PropertyTypeSelectGroup } from "../singleSelectGroup";
import { useMapFiltersStore } from "../../../stores/filterMapStore";
import { type KeyboardEvent, useEffect, useRef, useState } from "react";
import { propertyPreferences } from "../../../mocks/propertyPreferencesData";
import { PropertyTypeEnum } from "../../../interfaces/buyerMatchingPreferences";
import {
  useFilterPanelStore,
  useMatchFiltersStore,
} from "../../../stores/filterStore";
import {
  propertyActiveFilter,
  propertyDeListedAndSoldFilter,
} from "../../../mocks/newMockData/filterPanelData";
import { useAuth } from "../../../context/authProvider";
import { useShowLoginModalStore } from "../../../stores/loginModalStore";

interface FilterPanelProps {
  panelOpen: boolean;
  mapOpen?: boolean;
}

const mapEnumToLabel = (enumValue: PropertyTypeEnum): string => {
  switch (enumValue) {
    case PropertyTypeEnum.Detached:
      return "Detached";
    case PropertyTypeEnum.SemiDetached:
      return "Semi-Detached";
    case PropertyTypeEnum.Townhouse:
      return "Freehold Townhouse";
    case PropertyTypeEnum.CondoTownhouse:
      return "Condo Townhouse";
    case PropertyTypeEnum.Condo:
      return "Condo Apt";
    case PropertyTypeEnum.Multiplex:
      return "Multiplex";
    case PropertyTypeEnum.VacantLand:
      return "VacantLand";
    default:
      return "";
  }
};

export const mapPropertyTypeForPost = (
  propertyTypeLabel: string
): PropertyTypeEnum | null => {
  switch (propertyTypeLabel) {
    case "Detached":
      return PropertyTypeEnum.Detached;
    case "Semi-Detached":
      return PropertyTypeEnum.SemiDetached;
    case "Condo Townhouse":
      return PropertyTypeEnum.CondoTownhouse;
    case "Freehold Townhouse":
      return PropertyTypeEnum.Townhouse;
    case "Condo Apt":
      return PropertyTypeEnum.Condo;
    case "Multiplex":
      return PropertyTypeEnum.Multiplex;
    case "Vacant Land":
      return PropertyTypeEnum.VacantLand;
    default:
      return null;
  }
};

const MIN = 0;
const MAX_PRICE = 5000000;
const MAX_SQUARE_FOOTAGE = 4000;
const MAX_MAINTENANCE = 1500;

const FilterPanel = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [openDropdownType, setOpenDropdownType] = useState<string | null>("");
  const filterPanelRef = useRef<HTMLDivElement>(null);
  const {
    toggleFilterPanelVisible,
    hideFilterPanel,
    setFilterPanelOrigin,
    filterPanelOrigin,
    showFilterPanel,
    filterPanelVisible,
  } = useFilterPanelStore();
  const { showLoginModal, setShowLoginModal } = useShowLoginModalStore();
  const { authenticated } = useAuth();
  const {
    propertyPrice,
    setPropertyPrice,
    setPropertySquareFootage,
    propertySquareFootage,
    propertyMaintenanceFee,
    setPropertyMaintenanceFee,
    keywordSearch,
    setKeywordSearch,
    setBeds,
    setBaths,
    setDens,
    setParking,
    beds,
    baths,
    parking,
    dens,
    basement,
    openHouseType,
    clearAllFilters,
    setReloadMapCities,
    setOpenFilterPanel,
    openFilterPanel,
    propertyType,
    setPropertyTypeLocal,
    propertyTypeLocal,
    setPropertyType,
    selectedOptions,
    setSelectedOption,
    togglesPropertyType,
    setTogglesPropertyType,
    togglePropertyTypeButton,
  } = useMapFiltersStore();

  const [localBeds, setLocalBeds] = useState(["All"]);
  const [localBaths, setLocalBaths] = useState(["All"]);
  const [localPropertyPrice, setLocalPropertyPrice] = useState([0, 5000000]);
  const [localSelectedOptions, setLocalSelectedOptions] = useState({
    active: { value: "All", displayValue: "All" },
  });
  const [localSelectedOptionss, setLocalSelectedOptionss] = useState({
    sold: { value: "WITHIN_007_DAYS", displayValue: "7D" },
  });

  const [localTogglesPropertyType, setLocalTogglesPropertyType] = useState({
    active: true,
    sold: false,
    de_listed: false,
  });

  const togglePropertyTypeButtonLocal = (propertyType: string) => {
    setLocalTogglesPropertyType((prev) => ({
      ...prev,
      [propertyType]: !prev[propertyType],
    }));
  };

  const handleBedsChange = (newBeds: string[]) => {
    setLocalBeds(newBeds);
  };

  const handleBathsChange = (newBaths: string[]) => {
    setLocalBaths(newBaths);
  };

  const {
    clearAllMatchFilters,
    matchBedCount,
    matchBathCount,
    matchParking,
    matchDenCount,
    matchPropertyType,
    setMatchPropertyType,
    setMatchBedCount,
    setMatchBathCount,
    setMatchParking,
    setMatchDenCount,
  } = useMatchFiltersStore();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterPanelRef.current &&
        !filterPanelRef.current.contains(event.target as Node)
      ) {
        hideFilterPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hideFilterPanel]);

  const filterPanelHeaderString =
    filterPanelOrigin === "searchField" ? "Search Filters" : "Matching Filters";

  const toggleDropdown = (
    type: string,
    e?: KeyboardEvent<HTMLButtonElement>
  ) => {
    if (!e || e.key === "Enter" || e.key === " ") {
      setOpenDropdownType((prev) => (prev === type ? null : type));
    }
  };

  const handleDrawer = () => {
    toggleFilterPanelVisible();
  };

  const handleCloseFilterPanel = () => {
    clearAllMatchFilters();
    hideFilterPanel();
    setFilterPanelOrigin("");

    if (filterPanelOrigin === "searchField") {
      setReloadMapCities(true);
    }
  };

  const parkingCount = parking;
  const setParkingCount = setParking;

  const denCount = dens;
  const setDenCount = setDens;

  const handleButtonClick = async () => {
    setLoading(true);
    setBeds(localBeds);
    setBaths(localBaths);
    setPropertyPrice(localPropertyPrice);
    setPropertyType(() => [...propertyTypeLocal]);
    Object.keys(localSelectedOptions).map((key) => {
      setSelectedOption(
        key,
        localSelectedOptions[key as keyof typeof localSelectedOptions]
      );
    });
    Object.keys(localSelectedOptionss).map((key) => {
      setSelectedOption(
        key,
        localSelectedOptionss[key as keyof typeof localSelectedOptionss]
      );
    });

    setTogglesPropertyType({
      active: localTogglesPropertyType.active,
      sold: localTogglesPropertyType.sold,
      de_listed: localTogglesPropertyType.de_listed,
    });

    setReloadMapCities(true);
    handleDrawer();
  };

  useEffect(() => {
    setReloadMapCities(true);
    setLocalBaths(baths);
    setLocalBeds(beds);
    setPropertyTypeLocal(() => [...propertyType]);
    setLocalPropertyPrice(propertyPrice);
    setLocalSelectedOptions({
      active: {
        value: selectedOptions.active.value,
        displayValue: selectedOptions.active.displayValue,
      },
    });
    setLocalSelectedOptionss({
      sold: {
        value: selectedOptions.sold.value,
        displayValue: selectedOptions.sold.displayValue,
      },
    });
    setLocalTogglesPropertyType((prev) => ({
      ...prev,
      active: togglesPropertyType.active,
      sold: togglesPropertyType.sold,
      de_listed: togglesPropertyType.de_listed,
    }));
  }, [
    beds,
    baths,
    propertyType,
    propertyPrice,
    selectedOptions.active,
    selectedOptions.sold,
    selectedOptions.de_listed,
    togglesPropertyType,
  ]);

  useEffect(() => {
    setLocalBaths(baths);
    setLocalBeds(beds);
    setPropertyTypeLocal(() => [...propertyType]);
    setLocalPropertyPrice(propertyPrice);
    setLocalSelectedOptions({
      active: {
        value: selectedOptions.active.value,
        displayValue: selectedOptions.active.displayValue,
      },
    });
    setLocalSelectedOptionss({
      sold: {
        value: selectedOptions.sold.value,
        displayValue: selectedOptions.sold.displayValue,
      },
    });
    setLocalTogglesPropertyType((prev) => ({
      ...prev,
      active: togglesPropertyType.active,
      sold: togglesPropertyType.sold,
      de_listed: togglesPropertyType.de_listed,
    }));
  }, [openFilterPanel]);

  return (
    <div className="grid grid-cols-3 gap-7 grid-rows-1">
      <div className="space-y-6">
        <PropertyTypeSelector />
        <div className="border-2 border-[#EEE] rounded-[20px] divide-y-2">
          <div className="px-6 py-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <ToggleButton
                togglePropertyTypeButton={togglePropertyTypeButtonLocal}
                togglesPropertyType={localTogglesPropertyType}
                propertyType="active"
              />
              <span className="text-lg font-medium text-z-shark">Active</span>
            </div>
            <Dropdown
              selectedOptions={localSelectedOptions}
              setSelectedOption={(label, option) => {
                setLocalSelectedOptions((prevState) => ({
                  ...prevState,
                  [label]: option,
                }));
              }}
              positionY="bottom"
              label="active"
              options={propertyActiveFilter}
            />
          </div>
          <div className="px-6 py-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <ToggleButton
                togglePropertyTypeButton={() => {
                  if (authenticated) {
                    togglePropertyTypeButtonLocal;
                  } else {
                    setShowLoginModal(true);
                  }
                }}
                togglesPropertyType={localTogglesPropertyType}
                propertyType="sold"
              />
              <span className="text-lg font-medium text-z-shark">Sold</span>
            </div>
            <Dropdown
              selectedOptions={localSelectedOptionss}
              setSelectedOption={(label, option) => {
                setLocalSelectedOptionss((prevState) => ({
                  ...prevState,
                  [label]: option,
                }));
              }}
              positionY="bottom"
              label="sold"
              options={propertyDeListedAndSoldFilter}
            />
          </div>
          <div className="px-6 py-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <ToggleButton
                togglePropertyTypeButton={togglePropertyTypeButtonLocal}
                togglesPropertyType={localTogglesPropertyType}
                propertyType="de_listed"
              />
              <span className="text-lg font-medium text-z-shark">
                De-Listed
              </span>
            </div>
            <Dropdown
              selectedOptions={selectedOptions}
              setSelectedOption={setSelectedOption}
              positionY="bottom"
              label="de_listed"
              options={propertyDeListedAndSoldFilter}
            />
          </div>
        </div>
      </div>

      <div className="space-y-7">
        <div className="flex flex-col divide-y border py-3 border-[#EEE] rounded-[20px]">
          <MultiSelectGroup
            gap="12px"
            selectedValue={localBeds}
            label="Bedrooms"
            onChange={(values) => {
              const updatedValues = values.map((value) =>
                value === "5+" ? "5" : value
              );
              handleBedsChange(updatedValues);
            }}
            options={propertyPreferences.beds.map((item) => ({
              label: item.value === 5 ? "5+" : item.label,
              value: String(item.value === null ? "All" : item.value),
            }))}
            customClassName="text-[#B8B8B8]"
            spaceX="px-4 py-2 !mb-0 !space-y-1.5"
            labelTextSize="!text-[16px]"
          />
          <PropertyTypeSelectGroup
            gap="12px"
            selectedValue={denCount}
            label="Den"
            onChange={setDenCount}
            options={propertyPreferences.dens.map((item) => item)}
            customClassName="text-[#B8B8B8]"
            spaceX="px-4 py-2 !mb-0 !space-y-2"
            labelTextSize="!text-[16px]"
          />

          <MultiSelectGroup
            gap="12px"
            selectedValue={localBaths}
            label="Bathrooms"
            onChange={(values) => {
              const updatedValues = values.map((value) =>
                value === "5+" ? "5" : value
              );
              handleBathsChange(updatedValues);
            }}
            options={propertyPreferences.beds.map((item) => ({
              label: item.value === 5 ? "5+" : item.label,
              value: String(item.value === null ? "All" : item.value),
            }))}
            customClassName="text-[#B8B8B8]"
            spaceX="px-4 py-2 !mb-0 !space-y-2"
            labelTextSize="!text-[16px]"
          />

          <MultiSelectGroup
            gap="12px"
            selectedValue={parkingCount}
            label="Parking"
            onChange={(values) => {
              const updatedValues = values.map((value) =>
                value === "5+" ? "5" : value
              );
              setParkingCount(updatedValues);
            }}
            options={propertyPreferences.beds.map((item) => ({
              label: item.value === 5 ? "5+" : item.label,
              value: String(item.value === null ? "All" : item.value),
            }))}
            customClassName="text-[#B8B8B8]"
            spaceX="px-4 py-2 !mb-0 !space-y-2"
            labelTextSize="!text-[16px]"
          />
        </div>
        <div className="h-[60px] relative py-4 px-4 bg-white rounded-xl border-[1px] border-[#E1E0E3] w-full">
          <div className="overflow-hidden h-full w-full">
            <span className="absolute text-[#676473] -top-3 bg-white px-2 left-3">
              Keyword Search (One word)
            </span>
            <input
              value={keywordSearch || ""}
              onChange={(e) => setKeywordSearch(e.target.value)}
              className="w-full"
              placeholder="Waterfront, Pool, Fireplace..."
            />
          </div>
        </div>
        <DropdownSelector
          customDropdown={true}
          title={"Basement"}
          openType={"basement"}
          openDropdownType={openDropdownType}
          dropdownValue={basement}
          toggleDropdown={toggleDropdown}
        />
      </div>

      <div className="flex flex-col space-y-5">
        {/* <DropdownSelector
					customDropdown={true}
					title={"Open House"}
					openType={"openHouse"}
					openDropdownType={openDropdownType}
					dropdownValue={openHouseType}
					toggleDropdown={toggleDropdown}
				/> */}

        <div className="space-y-14 relative">
          <div className="text-z-shark font-medium">Price</div>

          <div className="px-4">
            <Range
              values={localPropertyPrice}
              step={25000}
              min={MIN}
              max={MAX_PRICE}
              onChange={(values) => setLocalPropertyPrice(values)}
              renderTrack={({ props, children }) => (
                <div
                  {...props}
                  className="w-full h-2 bg-[rgba(0,0,0,0.04)] rounded"
                  style={{
                    ...props.style,
                    background: getTrackBackground({
                      values: localPropertyPrice,
                      colors: [
                        "rgba(0, 0, 0, 0.04)",
                        "#456930",
                        "rgba(0, 0, 0, 0.04)",
                      ],
                      min: MIN,
                      max: MAX_PRICE,
                    }),
                  }}
                >
                  {children}
                </div>
              )}
              renderThumb={({ props, index }) => (
                <div
                  {...props}
                  className="h-6 w-6 border-2 border-z-dark-moss-green bg-white rounded-full flex items-center justify-center focus:outline-none relative"
                  style={{
                    ...props.style,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.10)",
                  }}
                >
                  <div className="text-xs font-bold bg-z-dark-moss-green text-white min-w-[65px] px-2 text-center rounded-lg py-1 absolute -top-[36px]">
                    {/* ${propertyPrice[index]}k */}
                    {localPropertyPrice[index] === MAX_PRICE
                      ? "Max"
                      : `$${formatPrice(localPropertyPrice[index])}`}
                    <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[7px] border-transparent border-t-z-dark-moss-green absolute -bottom-[6px] left-1/2 -translate-x-1/2" />
                  </div>
                </div>
              )}
            />
          </div>

          <div className="flex justify-between w-full absolute top-12">
            <span className="font-normal text-[#676473] text-xs">0%</span>
            <span className="font-normal text-[#676473] text-xs">Max</span>
          </div>
        </div>

        <div className="space-y-14 relative pt-10">
          <div className="text-z-shark font-medium">Square Footage (sqft)</div>
          <div className="px-4">
            <Range
              values={propertySquareFootage}
              step={50}
              min={MIN}
              max={MAX_SQUARE_FOOTAGE}
              onChange={(values) => setPropertySquareFootage(values)}
              renderTrack={({ props, children }) => (
                <div
                  {...props}
                  className="w-full h-2 bg-[rgba(0,0,0,0.04)] rounded"
                  style={{
                    ...props.style,
                    background: getTrackBackground({
                      values: propertySquareFootage,
                      colors: [
                        "rgba(0, 0, 0, 0.04)",
                        "#456930",
                        "rgba(0, 0, 0, 0.04)",
                      ],
                      min: MIN,
                      max: MAX_SQUARE_FOOTAGE,
                    }),
                  }}
                >
                  {children}
                </div>
              )}
              renderThumb={({ props, index }) => (
                <div
                  {...props}
                  className="h-6 w-6 border-2 border-z-dark-moss-green bg-white rounded-full flex items-center justify-center focus:outline-none relative"
                  style={{
                    ...props.style,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.10)",
                  }}
                >
                  <div className="text-xs font-bold bg-z-dark-moss-green text-white min-w-[65px] text-center rounded-lg py-1 absolute -top-[36px]">
                    {propertySquareFootage[index] === MAX_SQUARE_FOOTAGE
                      ? "Max"
                      : `${propertySquareFootage[index]}`}
                    <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[7px] border-transparent border-t-z-dark-moss-green absolute -bottom-[6px] left-1/2 -translate-x-1/2" />
                  </div>
                </div>
              )}
            />
          </div>
        </div>

        <div className="space-y-14 relative pt-10">
          <div className="text-z-shark font-medium">
            Maximum Maintenance Fee
          </div>
          <div className="px-4">
            <Range
              values={propertyMaintenanceFee}
              step={50}
              min={MIN}
              max={MAX_MAINTENANCE}
              onChange={(values) => setPropertyMaintenanceFee(values)}
              renderTrack={({ props, children }) => (
                <div
                  {...props}
                  className="w-full h-2 bg-[rgba(0,0,0,0.04)] rounded"
                  style={{
                    ...props.style,
                    background: getTrackBackground({
                      values: propertyMaintenanceFee,
                      colors: [
                        "rgba(0, 0, 0, 0.04)",
                        "#456930",
                        "rgba(0, 0, 0, 0.04)",
                      ],
                      min: MIN,
                      max: MAX_MAINTENANCE,
                    }),
                  }}
                >
                  {children}
                </div>
              )}
              renderThumb={({ props, index }) => (
                <div
                  {...props}
                  className="h-6 w-6 border-2 border-z-dark-moss-green bg-white rounded-full flex items-center justify-center focus:outline-none relative"
                  style={{
                    ...props.style,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.10)",
                  }}
                >
                  <div className="text-xs font-bold bg-z-dark-moss-green text-white min-w-[65px] text-center rounded-lg py-1 absolute -top-[36px]">
                    {propertyMaintenanceFee[index] === MAX_MAINTENANCE
                      ? "Max"
                      : `$${formatPrice(propertyMaintenanceFee[index])}`}
                    <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[7px] border-transparent border-t-z-dark-moss-green absolute -bottom-[6px] left-1/2 -translate-x-1/2" />
                  </div>
                </div>
              )}
            />
          </div>
        </div>

        <div className="w-full space-x-4 flex items-center justify-center pt-8">
          <Button
            onClick={() => {
              clearAllFilters();
              setOpenFilterPanel(false);
            }}
            isOutlined={true}
            customClassName="text-z-shark font-semibold border-[1px] !border-[#CACACA]"
            radius="60px"
            width="160px"
          >
            Clear All
          </Button>

          <Button
            onClick={() => {
              handleButtonClick();
              setOpenFilterPanel(false);
            }}
            radius="60px"
            width="160px"
            customClassName="font-semibold"
            // disable={loading}
          >
            Apply Filter
          </Button>
        </div>
      </div>
    </div>
  );
};

export { FilterPanel };
